import React from 'react';
import { Loader2 } from 'lucide-react';

const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  disabled = false,
  loading = false,
  onClick,
  type = 'button',
  className = '',
  icon,
  iconPosition = 'left',
  fullWidth = false,
  ...props
}) => {
  const baseClasses = 'inline-flex items-center justify-center font-medium rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';

  const variants = {
    primary: 'bg-agrosaf-green hover:bg-agrosaf-darkGreen text-white focus:ring-agrosaf-green',
    secondary: 'bg-agrosaf-blue hover:bg-agrosaf-darkBlue text-white focus:ring-agrosaf-blue',
    outline: 'border border-gray-300 hover:border-gray-400 text-gray-700 hover:text-gray-900 focus:ring-gray-500',
    ghost: 'text-gray-600 hover:text-gray-900 hover:bg-gray-100 focus:ring-gray-500',
    danger: 'bg-red-600 hover:bg-red-700 text-white focus:ring-red-500',
    destructive: 'bg-red-600 hover:bg-red-700 text-white focus:ring-red-500', // Alias for danger
    success: 'bg-green-600 hover:bg-green-700 text-white focus:ring-green-500',
    warning: 'bg-yellow-600 hover:bg-yellow-700 text-white focus:ring-yellow-500'
  };

  const sizes = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-4 py-2 text-sm',
    lg: 'px-6 py-3 text-base',
    xl: 'px-8 py-4 text-lg'
  };

  const widthClass = fullWidth ? 'w-full' : '';

  const classes = `${baseClasses} ${variants[variant]} ${sizes[size]} ${widthClass} ${className}`;

  const renderIcon = () => {
    if (loading) {
      return <Loader2 className="animate-spin h-4 w-4" />;
    }
    if (icon) {
      return icon;
    }
    return null;
  };

  const renderContent = () => {
    const iconElement = renderIcon();

    if (!iconElement) return children;

    if (iconPosition === 'left') {
      return (
        <>
          {iconElement}
          {children && <span className="ml-2 flex items-center">{children}</span>}
        </>
      );
    } else {
      return (
        <>
          {children && <span className="mr-2 flex items-center">{children}</span>}
          {iconElement}
        </>
      );
    }
  };

  return (
    <button
      type={type}
      className={classes}
      disabled={disabled || loading}
      onClick={onClick}
      {...props}
    >
      {renderContent()}
    </button>
  );
};

export default Button;
